import { render, staticRenderFns } from "./AdminBatchReports.vue?vue&type=template&id=ec9b556c&scoped=true&"
import script from "./AdminBatchReports.vue?vue&type=script&lang=js&"
export * from "./AdminBatchReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminBatchReports.vue?vue&type=style&index=0&id=ec9b556c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9b556c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec9b556c')) {
      api.createRecord('ec9b556c', component.options)
    } else {
      api.reload('ec9b556c', component.options)
    }
    module.hot.accept("./AdminBatchReports.vue?vue&type=template&id=ec9b556c&scoped=true&", function () {
      api.rerender('ec9b556c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminBatchReports.vue"
export default component.exports